export default "__VITE_ASSET__9521d0f6__"